var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{attrs:{"options":_vm.topTooltipOptions}},[_vm._t("default",function(){return [_c('label',{staticClass:"form-label",class:{ disable_field: _vm.disabled }},[_vm._v(_vm._s(_vm.localeLabel))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }